import { Link, NavLink } from 'react-router-dom'
import './Layout.css'

const NAV_ITEMS = [
  { to: '/', label: 'Hjem', end: true },
  { to: '/nyheder', label: 'Nyheder' },
  {
    to: '/bat',
    label: 'Padel bat',
    isActive: (_, loc) =>
      loc.pathname.startsWith('/bat') || loc.pathname.startsWith('/products/'),
  },
  { to: '/search', label: 'Søg' },
]

function Layout({ children }) {
  return (
    <div className="layout">
      <header className="header">
        <div className="container">
          <Link to="/" className="logo">
            <h1>🏃 Sportsteknologi</h1>
          </Link>
          <nav className="nav">
            {NAV_ITEMS.map(({ to, label, end, className, isActive: isActiveFn }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                isActive={isActiveFn}
                className={({ isActive }) =>
                  [className, isActive ? 'nav-active' : ''].filter(Boolean).join(' ')
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      
      <main className="main">
        {children}
      </main>
      
      <footer className="footer">
        <div className="container">
          <p>
            &copy; 2026 Sportsteknologi.dk - AI-drevet sportsudstyr guide
            {' · '}
            <Link to="/privatliv">Privatliv</Link>
          </p>
        </div>
      </footer>
    </div>
  )
}

export default Layout

